<template>
  <v-card>
    <v-form @submit.prevent="true" v-model="formValid" autocomplete="off">
      <v-container style="padding-top: 0px; padding-bottom: 0px">
        <v-row></v-row>
        <v-row>
          <v-col cols="3">
            <v-text-field required variant="underlined" :rules="NameRules" label="Name" v-model="approvalProcessType.name" auto-grow></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              :label="$t('Change_Category')"
              item-title="name"
              variant="underlined"
              item-value="clientID"
              v-model="approvalProcessType.changeCategory.clientID"
              :items="ChangeCategories"
              required
              :rules="requiredRules"
            >
              <template slot="selection" slot-scope="data">
                {{ data.item.name }} {{ data.item.enabled ? '' : '(Disabled)' }}
              </template>
              <template slot="item" slot-scope="data">
                {{ data.item.name }} {{ data.item.enabled ? '' : '(Disabled)' }}
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-text-field type="number" variant="underlined" label="Display Order" v-model="approvalProcessType.displayOrder"></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              type="number"
              variant="underlined"
              label="Approval Days"
              :model-value="approvalProcessType.approvalDays"
              @update:modelValue="onApprovalDaysChange"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row style="padding-bottom: 10px">
          <v-col cols="12" sm="6" class="pt-0">
            <v-autocomplete
              label="Approval Type"
              variant="underlined"
              item-title="value"
              item-value="key"
              v-model="approvalProcessType.approvalType"
              :items="ApprovalTypes"
              required
              :error-messages="approvalTypeErrors"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" class="pt-0">
            <people-picker
              :label="$t('Owner')"
              :user="approvalProcessType.owner"
              @clear="approvalProcessType.owner = null"
              v-model="approvalProcessType.owner"
            ></people-picker>
          </v-col>

          <v-col cols="12" sm="6">
            <people-picker-ms
              @update="(args) => this.handleApproversUpdate(args)"
              v-model="approvalProcessType.approvers"
              :title="$t('Approvers')"
              showRequired
              bulkUserAdd
            ></people-picker-ms>
          </v-col>
          <v-col cols="12" sm="6">
            <people-picker-ms
              @update="(args) => this.handleFyisUpdate(args)"
              v-model="approvalProcessType.fyis"
              :title="$t('FYI')"
              bulkUserAdd
            ></people-picker-ms>
          </v-col>
        </v-row>
        <v-row v-if="hasTemporaryEnabled">
          <v-col cols="12" sm="6">
            <people-picker
              v-model="approvalProcessType.lineManager"
              label="Line Manager"
              @clear="approvalProcessType.lineManager = undefined"
              :user="approvalProcessType.lineManager"
              :errorMessages="requiredPeoplePickerLineManagerError"
            ></people-picker>
          </v-col>
          <v-col cols="12" sm="6">
            <people-picker
              v-model="approvalProcessType.vp"
              :user="approvalProcessType.vp"
              label="Senior Management"
              @clear="approvalProcessType.vp = undefined"
              :errorMessages="requiredPeoplePickerVpsError"
            ></people-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-toolbar elevation="1" density="compact" :title="$t('Multipass')"></v-toolbar>
              <v-container fluid>
                <v-row>
                  <v-col cols="12" sm="4">
                    <v-text-field
                      v-model="decisionPasses"
                      readonly
                      variant="underlined"
                      :prepend-icon="lowerLimitReached() ? undefined : 'mdi-minus-circle-outline'"
                      :append-icon="upperLimitReached() ? undefined : 'mdi-plus-circle-outline'"
                      label="Additional Approval Passes"
                      @click:prepend="removePass"
                      @click:append="addPass"
                      persistent-hint
                      :hint="decisionPasses > 0 ? 'Multipass enabled' : 'Multipass NOT enabled'"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col>
                    <v-radio-group v-model="outletRadios" :mandatory="false">
                      <v-radio label="Return To Submit" value="1" @change="setOutletStatus('1')"></v-radio>
                      <v-radio label="Return to Available For Decision" value="2" @change="setOutletStatus('2')"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>

                <v-row v-for="(pass, index) in approvalProcessType.multiPass.approvalPasses" :key="index">
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="pass.label"
                      variant="underlined"
                      :label="'Pass'.concat('', pass.pass.toString(), ' ', 'Label')"
                      :key="index"
                      :error-messages="passLabelErrorMessages(pass)"
                      :rules="passLabelRequiredRules"
                    >
                    </v-text-field>

                    <people-picker-ms
                      v-model="pass.approvers"
                      @update="(args) => handleMpassApproverUpdate(pass, args)"
                      :title="'Pass '.concat(pass.pass, ' -- ', pass.label, ' -- ', $t('Approvers'))"
                      :showCounter="true"
                      :color="isSubmittedOutletStatus ? null : pass.approvers.length > 0 ? null : 'error'"
                      :showRequired="true"
                    ></people-picker-ms>

                    <people-picker-ms
                      v-model="pass.fyis"
                      @update="(args) => handleMpassFyisUpdate(pass, args)"
                      :title="'Pass '.concat(pass.pass, ' -- ', pass.label, ' -- ', $t('Fyis'))"
                      :showCounter="true"
                      :showRequired="true"
                    ></people-picker-ms>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>

        <v-card-actions>
          <v-row justify="end">
            <v-btn :disabled="!this.validApprovers || !this.formValid" color="success" @click="save">Save</v-btn>
            <v-btn @click="close">Close</v-btn>
            <v-btn color="error" variant="flat" @click="deleteApprovalProcessType">Delete</v-btn>
          </v-row>
        </v-card-actions>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import PeoplePickerMs from '@/components/peoplePicker/PeoplePickerMs'
import PeoplePicker from '@/components/peoplePicker/PeoplePicker'
import { FormStatus } from '@/common'
export default {
  name: 'approvalProcessType',
  data() {
    return {
      formValid: false,
      expanded: false,
      minimumNameLength: 1,
      maximumNameLength: 120,
      minimumTranslationLength: 1,
      maximumTranslationLength: 300,
      requiredRules: [(v) => !!v || 'Required'],
      passLabelRequiredRules: [(v) => (!v || (v && !v.trim()) ? 'Required' : true)],
      decisionPasses: 0,

      passLabels: [],
      outletRadios: '1'
    }
  },
  methods: {
    addPass: function () {
      let totalPasses = (this.decisionPasses += 1)
      this.approvalProcessType.decisionPasses = totalPasses
      if (!this.approvalProcessType.multiPass) {
        this.approvalProcessType.multiPass = {}
      }

      if (!this.approvalProcessType.multiPass.approvalPasses) {
        this.approvalProcessType.multiPass.approvalPasses = []
      }

      this.approvalProcessType.multiPass.approvalPasses.push({
        pass: this.decisionPasses,
        approvers: [],
        fyis: [],
        label: ''
      })

      this.approvalProcessType.multiPass.enabled = true
    },
    removePass: function () {
      this.decisionPasses -= 1
      this.approvalProcessType.decisionPasses = this.decisionPasses
      this.approvalProcessType.multiPass.approvalPasses.pop()

      if (this.decisionPasses === 0) {
        this.approvalProcessType.multiPass.enabled = false
      }
    },
    save: function () {
      this.$emit('saveApprovalProcessType', this.approvalProcessType)
    },
    setOutletStatus: function (val) {
      if (val === '1') {
        this.approvalProcessType.multiPass.outletStatus = FormStatus.properties[FormStatus.SUBMITTED]
      } else {
        this.approvalProcessType.multiPass.outletStatus = FormStatus.properties[FormStatus.AVAILABLEFORDECISION]
      }

      this.outletRadios = val
    },
    close: function () {
      this.$emit('closeApprovalProcessType')
    },
    handleMpassApproverUpdate: function (pass, usersAction) {
      pass.approvers = usersAction.Users

      pass.approvers.forEach((p) => {
        p.decisionPass = pass.pass
      })
    },
    handleMpassFyisUpdate: function (pass, usersAction) {
      pass.fyis = usersAction.Users

      pass.fyis.forEach((p) => {
        p.decisionPass = pass.pass
      })
    },
    deleteApprovalProcessType: function () {
      this.$emit('deleteApprovalProcessType', this.approvalProcessType)
    },
    onApprovalDaysChange(value) {
      this.approvalProcessType.approvalDays = parseFloat(value)
    },
    lowerLimitReached: function () {
      return this.approvalProcessType.multiPass.approvalPasses.length === 0
    },
    upperLimitReached: function () {
      return this.approvalProcessType.multiPass.approvalPasses.length >= 5
    },
    handleApproversUpdate(usersAction) {
      this.approvalProcessType.approvers = usersAction.Users
    },
    handleFyisUpdate(usersAction) {
      this.approvalProcessType.fyis = usersAction.Users
    },
    passLabelErrorMessages(pass) {
      return !pass.label || (pass.label && !pass.label.trim()) ? 'Required' : null
    }
  },
  computed: {
    multiPassComputed() {
      return this.approvalProcessType.multiPass
    },
    isSubmittedOutletStatus() {
      return (
        this.approvalProcessType.multiPass.outletStatus &&
        this.approvalProcessType.multiPass.outletStatus.value === FormStatus.properties[FormStatus.SUBMITTED].value
      )
    },
    validApprovers() {
      if (!this.approvalProcessType.multiPass.enabled) {
        return true
      }

      if (
        this.approvalProcessType.multiPass.outletStatus &&
        this.approvalProcessType.multiPass.outletStatus.value === FormStatus.properties[FormStatus.SUBMITTED].value
      ) {
        return true
      }
      return (
        this.approvalProcessType.multiPass.approvalPasses.filter((p) => {
          return p.approvers.length === 0
        }).length === 0
      )
    },
    approvalTypeErrors: {
      get: function () {
        return this.approvalProcessType.approvalType == null ? 'Approval type is required' : null
      }
    },
    NameRules: {
      get: function () {
        return [
          (v) => !!v || 'Name is required',
          (v) => (v && v.trim().length >= this.minimumNameLength) || `Minimum length is ${this.minimumNameLength}`,
          (v) => (v && v.trim().length <= this.maximumNameLength) || `Maximum length is ${this.maximumNameLength}`
        ]
      }
    },
    requiredPeoplePickerLineManagerError() {
      return this.approvalProcessType.lineManager ? null : 'Line manager is required'
    },
    requiredPeoplePickerVpsError() {
      return this.approvalProcessType.vp ? null : 'Senior Management is required'
    }
  },
  props: {
    approvalProcessType: Object,
    ApprovalTypes: Array,
    ChangeCategories: Array,
    hasTemporaryEnabled: Boolean
  },
  components: {
    PeoplePickerMs,
    PeoplePicker
  },
  mounted() {
    if (!this.approvalProcessType.multiPass) {
      this.approvalProcessType.multiPass = {}
    }

    if (!this.approvalProcessType.multiPass.approvalPasses) {
      this.approvalProcessType.multiPass.approvalPasses = []
    }

    if (this.approvalProcessType.multiPass.approvalPasses.length > 0) {
      this.decisionPasses = this.approvalProcessType.multiPass.approvalPasses.length
    }

    if (
      this.approvalProcessType.multiPass.outletStatus &&
      this.approvalProcessType.multiPass.outletStatus.value === FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value
    ) {
      this.setOutletStatus('2')
    } else {
      this.setOutletStatus('1')
    }
  },
  watch: {
    multiPassComputed() {
      this.$forceUpdate()
    }
  }
}
</script>
